<template>
  <div class="bright-horizons-section-container">
    <div class="bright-horizons-section mx-auto px-16">
      <div class="grid lg:grid-cols-2 grid-cols-1 gap-16 lg:pt-96 md:pt-76 pt-60">
        <div class="col">
          <img src="@/images/bh-benefits/bh-sittercity-dual-logo.svg" alt="Sittercity and Bright Horizons logos" />
          <h2 class="text-h2 my-16">Part of the Bright Horizons family since 2020</h2>
          <p class="text-body">
            Together, we aim to elevate how families find and experience child care. Through Sittercity’s trusted marketplace and
            Bright Horizons’ deep child care expertise, our shared vision is to help families thrive with customized and enriching
            care.
          </p>
          <img
            src="@/images/bh-benefits/more-bh-benefits.svg"
            alt="More Bright Horizons benefits"
            class="mt-32 lg:mt-56 more-bh-benefits"
          />
        </div>
        <div class="col hidden lg:block">
          <img src="@/images/bh-benefits/plane-kids.svg" alt="Two kids in an airplane costume" />
        </div>
      </div>
      <div class="grid lg:grid-cols-2 grid-cols-1 gap-16 lg:relative lg:-top-48 mt-16 lg:mt-0">
        <card>
          <h4 class="text-h4">Child Care Centers</h4>
          <p class="text-body mt-6">Early education and preschool that’s more than daycare</p>
        </card>
        <card>
          <h4 class="text-h4">Tutoring</h4>
          <p class="text-body mt-6">Individualized virtual or in-person tutoring support</p>
        </card>
        <card>
          <h4 class="text-h4">Back-Up Care</h4>
          <p class="text-body mt-6">Your trusted safety net when regular child care plans are disrupted</p>
        </card>
        <card>
          <h4 class="text-h4">Steve & Kate’s Camp</h4>
          <p class="text-body mt-6">Kid-directed, flexible, year round camps</p>
        </card>
        <card>
          <h4 class="text-h4">College Coach</h4>
          <p class="text-body mt-6">
            Learn proven strategies for the best ways to navigate the college admissions process and finance an education
          </p>
        </card>
        <card>
          <h4 class="text-h4">EdAssist</h4>
          <p class="text-body mt-6">Personalized tools for you to continue your education and advance your career</p>
        </card>
      </div>
      <Button
        variant="arrow"
        value="See eligibility at MyBright Horizons"
        class="mt-32 mb-72 lg:mt-0 hidden lg:inline-flex"
        href="https://my.brighthorizons.com/"
        target="_blank"
        @click="seeEligibilityButtonClicked"
      />
      <Button
        variant="arrow"
        value="See your eligibility"
        class="mt-32 mb-48 lg:hidden"
        href="https://my.brighthorizons.com/"
        target="_blank"
        @click="seeEligibilityButtonClicked"
      />
    </div>
  </div>
</template>

<script lang="ts">
import Card from '@/components/card/Card.vue';
import Button from '@/components/button/Button.vue';
import { sendSegmentEvent } from '../../../lib/segment';

export default {
  name: 'BrightHorizonsSection',
  components: { Card, Button },

  methods: {
    seeEligibilityButtonClicked() {
      const date = new Date().toLocaleString('default', { month: 'long', day: 'numeric', year: 'numeric' });
      const time = new Date().toLocaleTimeString('default', { hour: 'numeric', minute: 'numeric', second: 'numeric' });
      const path = this.$route.query;

      sendSegmentEvent('myBH Eligibility Clicked', {
        click_date: date,
        time_stamp: time,
        url: path,
      });
    },
  },
};
</script>
